import React from 'react'
import PropTypes from 'prop-types'
import { setDisplayName, pure, setPropTypes, onlyUpdateForPropTypes, compose, defaultProps } from 'recompose'

import './ModalContent.css'

import cancelIcon from '../../../assets/icons/cancel.svg'

import { Loading } from '../Loading/Loading'
import {connect} from "react-redux";

const propTypes = setPropTypes({
  children: PropTypes.any,
  active: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
})

const mapStateToProps = (state) => ({
  language: state.userData.language
})

const enhance = compose(
  setDisplayName('ModalContent'),
  pure,
  connect(mapStateToProps, null),
  onlyUpdateForPropTypes,
  propTypes,
  defaultProps({
    onClose: () => {}
  })
)

const View = ({active, loading, children, onClose, styles}) => (
  <div className="ModalContent" data-active={active}>
    <div className="ModalContent__shadow" onClick={onClose} />
    <div style={styles} className="ModalContent__content">
      <button className="ModalContent__close-btn" onClick={onClose}>
        <img src={cancelIcon} alt="cancel"/>
      </button>
      {children}
      <Loading active={loading} />
    </div>
  </div>
)

export const ModalContent = enhance(View)



// WEBPACK FOOTER //
// ./src/components/Shared/ModalContent/ModalContent.js